/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamRevisionLangMutationRequest,
  PostApiV1ExamRevisionLangMutationResponse,
  PostApiV1ExamRevisionLang400,
  PostApiV1ExamRevisionLang401,
  PostApiV1ExamRevisionLang404,
  PostApiV1ExamRevisionLang500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLang.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamRevisionLang } from "../../clients/examRevisionController/postApiV1ExamRevisionLang.ts";

export const postApiV1ExamRevisionLangMutationKey = () =>
  [{ url: "/api/v1/exam/revision/lang" }] as const;

export type PostApiV1ExamRevisionLangMutationKey = ReturnType<
  typeof postApiV1ExamRevisionLangMutationKey
>;

export function postApiV1ExamRevisionLangMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1ExamRevisionLangMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1ExamRevisionLangMutationKey();
  return mutationOptions<
    PostApiV1ExamRevisionLangMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLang400
      | PostApiV1ExamRevisionLang401
      | PostApiV1ExamRevisionLang404
      | PostApiV1ExamRevisionLang500
    >,
    { data?: PostApiV1ExamRevisionLangMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ExamRevisionLang(data, config);
    },
  });
}

/**
 * @description Cria um novo idioma (ClassroomDisciplineBotExamLang) para a prova gerada por IA informada. Valida que a combinação BotExamId + CultureInfo ainda não existe antes de persistir. O status inicial do idioma criado é PendingReview. **(Requer Authorization para autenticação)**
 * @summary Criar idioma para prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang}
 */
export function usePostApiV1ExamRevisionLang<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamRevisionLangMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamRevisionLang400
        | PostApiV1ExamRevisionLang401
        | PostApiV1ExamRevisionLang404
        | PostApiV1ExamRevisionLang500
      >,
      { data?: PostApiV1ExamRevisionLangMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ExamRevisionLangMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1ExamRevisionLangMutationKey();

  const baseOptions = postApiV1ExamRevisionLangMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamRevisionLangMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLang400
      | PostApiV1ExamRevisionLang401
      | PostApiV1ExamRevisionLang404
      | PostApiV1ExamRevisionLang500
    >,
    { data?: PostApiV1ExamRevisionLangMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamRevisionLangMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLang400
      | PostApiV1ExamRevisionLang401
      | PostApiV1ExamRevisionLang404
      | PostApiV1ExamRevisionLang500
    >,
    { data?: PostApiV1ExamRevisionLangMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamRevisionLangMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLang400
      | PostApiV1ExamRevisionLang401
      | PostApiV1ExamRevisionLang404
      | PostApiV1ExamRevisionLang500
    >,
    { data?: PostApiV1ExamRevisionLangMutationRequest },
    TContext
  >;
}
